import { clubService, clubServiceList, findMemberService } from '@http/clubService'
import { selectCredentials } from '@views/loginView/state/loginSlice'
import { call, takeEvery, put, select } from 'redux-saga/effects'
import {
  findMember,
  findMemberFailed,
  findMemberSuccess,
  getClub,
  getClubAction,
  getClubFailed,
  getClubList,
  getClubListFailed,
  getClubListSuccess,
  getClubSuccess
} from './clubSlice'
import { User } from '@types'
import { PayloadAction } from '@reduxjs/toolkit'

export function* getClubListSaga() {
  const { cocap, userId } = yield select(selectCredentials)
  try {
    const tree: User[] = yield call(clubServiceList, userId, cocap)
    yield put(getClubListSuccess(tree))
  } catch (e) {
    yield put(getClubListFailed(e.message))
  }
}

export function* getClubSaga({ payload: { date, userId } }: getClubAction) {
  const { cocap } = yield select(selectCredentials)
  try {
    const tree: User[] = yield call(clubService, userId, cocap, date)
    yield put(getClubSuccess(tree))
  } catch (e) {
    yield put(getClubFailed(e.message))
  }
}

export function* findMemberSaga({ payload }: PayloadAction<string>) {
  const { cocap, userId } = yield select(selectCredentials)
  try {
    const member: User = yield call(findMemberService, userId, cocap, payload)
    yield put(findMemberSuccess(member))
  } catch (e) {
    yield put(findMemberFailed(e.message))
  }
}

export default function* clubSaga() {
  yield takeEvery(getClub.type, getClubSaga)
  yield takeEvery(getClubList.type, getClubListSaga)
  yield takeEvery(findMember.type, findMemberSaga)
}
